import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import PickList from "../../components/PickList/PickList";
import { auth } from "../../service";

export default function ManageLists() {
    const navigate = useNavigate()
    
    useEffect(() => {
        if (!auth.currentUser){
            alert("usuário precisa estar logado para acessar esta página.");
            navigate('/login');
        }
    }, [navigate]);

    return (
        <>
            <Header />
            <PickList />
            
            <Footer />
        </>
    );
}